<ng-container *transloco="let t; scope: 'consent'; prefix: 'consent'">
  <de-modal
    #modalRoot
    variant="primary"
    size="lg"
    iconClass="bi-shield-check"
    [open]="isOpen()"
    [dismissible]="false"
    [closeOnBackdropClick]="false"
    [autoFocusOnOpen]="false"
    [colorHeader]="false"
    [title]="view() === 'intro' ? t('consentModal.intro.title') : t('consentModal.settings.title')"
  >
    <div deModalBody class="consent-modal">
      @if (view() === 'intro') {
        <div class="consent-modal__content">
          <p>{{ t('consentModal.intro.body1') }}</p>
          <p>{{ t('consentModal.intro.body2') }}</p>
        </div>

        <div class="consent-modal__actions">
          <de-button
            #primaryButton
            type="button"
            variant="primary"
            color="primary"
            [fullWidth]="true"
            (buttonClick)="onAcceptAll()"
          >
            {{ t('consentModal.intro.acceptAll') }}
          </de-button>

          <de-button
            type="button"
            variant="secondary"
            color="primary"
            [fullWidth]="true"
            (buttonClick)="onAcceptNecessary()"
          >
            {{ t('consentModal.intro.acceptNecessary') }}
          </de-button>

          <de-button
            type="button"
            variant="tertiary"
            color="primary"
            [fullWidth]="true"
            (buttonClick)="onOpenSettings()"
          >
            {{ t('consentModal.intro.settings') }}
          </de-button>
        </div>
      } @else {
        <div class="consent-modal__content">
          <section class="consent-modal__option" aria-labelledby="consent-necessary-title">
            <div class="consent-modal__option-copy">
              <h3 id="consent-necessary-title">{{ t('consentModal.settings.necessary.title') }}</h3>
              <p class="consent-modal__muted">{{ t('consentModal.settings.necessary.body') }}</p>
              <p class="consent-modal__label">{{ t('consentModal.settings.necessary.stripeTitle') }}</p>
              <p class="consent-modal__muted">{{ t('consentModal.settings.necessary.stripeBody') }}</p>
              <p class="consent-modal__muted">
                {{ t('consentModal.settings.necessary.stripeLinkIntro') }}
                <a href="https://stripe.com/de/privacy" target="_blank" rel="noreferrer">
                  {{ t('consentModal.settings.necessary.stripeLinkLabel') }}
                </a>
              </p>
              <p class="consent-modal__label">{{ t('consentModal.settings.necessary.note') }}</p>
              <p class="consent-modal__label">{{ t('consentModal.settings.necessary.required') }}</p>
            </div>

            <de-checkbox
              inputId="consent-necessary"
              [label]="t('consentModal.settings.necessary.alwaysActive')"
              [checked]="true"
              [disabled]="true"
            />
          </section>

          <section class="consent-modal__option" aria-labelledby="consent-analytics-title">
            <div class="consent-modal__option-copy" id="analytics-description">
              <h3 id="consent-analytics-title">{{ t('consentModal.settings.analytics.title') }}</h3>
              <p class="consent-modal__muted">{{ t('consentModal.settings.analytics.body') }}</p>
              <p class="consent-modal__muted">{{ t('consentModal.settings.analytics.toolsIntro') }}</p>
              <ul>
                <li>{{ t('consentModal.settings.analytics.tool1') }}</li>
                <li>{{ t('consentModal.settings.analytics.tool2') }}</li>
              </ul>
            </div>

            <de-checkbox
              inputId="consent-analytics"
              [label]="t('consentModal.settings.analytics.enable')"
              [checked]="analyticsSelected()"
              (checkedChange)="onAnalyticsToggle($event)"
            />
          </section>
        </div>

        <div class="consent-modal__actions">
          <de-button
            #primaryButton
            type="button"
            variant="primary"
            color="primary"
            [fullWidth]="true"
            (buttonClick)="onSaveSettings()"
          >
            {{ t('consentModal.settings.save') }}
          </de-button>

          <de-button
            type="button"
            variant="secondary"
            color="primary"
            [fullWidth]="true"
            (buttonClick)="onAcceptAll()"
          >
            {{ t('consentModal.settings.acceptAll') }}
          </de-button>

          <de-button
            type="button"
            variant="tertiary"
            color="primary"
            [fullWidth]="true"
            (buttonClick)="onBackToIntro()"
          >
            {{ t('consentModal.settings.back') }}
          </de-button>
        </div>
      }
    </div>
  </de-modal>
</ng-container>
